import React, { useEffect, useState } from "react";
import { useLocation, useNavigate } from "react-router-dom";
import { API, UPLOADS } from "./../../config/api";

export default function SearchResults() {
  const location = useLocation();
  const navigate = useNavigate();

  const [results, setResults] = useState([]);
  const [wishlist, setWishlist] = useState([]);

  const params = new URLSearchParams(location.search);

  const query = params.get("query");
  const type = params.get("type");

  /* ================= LOAD WISHLIST ================= */

  useEffect(() => {
    const user = JSON.parse(sessionStorage.getItem("user"));

    if (user) {
      const saved =
        JSON.parse(localStorage.getItem(`wishlist_${user.id}`)) || [];
      setWishlist(saved);
    }
  }, []);

  /* ================= SYNC WISHLIST ================= */

  useEffect(() => {
    const syncWishlist = () => {
      const user = JSON.parse(sessionStorage.getItem("user"));

      if (user) {
        const saved =
          JSON.parse(localStorage.getItem(`wishlist_${user.id}`)) || [];
        setWishlist(saved);
      }
    };

    window.addEventListener("cartUpdated", syncWishlist);
    window.addEventListener("storage", syncWishlist);

    return () => {
      window.removeEventListener("cartUpdated", syncWishlist);
      window.removeEventListener("storage", syncWishlist);
    };
  }, []);

  /* ================= TOGGLE WISHLIST ================= */

  const toggleWishlist = (item) => {
    const user = JSON.parse(sessionStorage.getItem("user"));

    if (!user) {
      navigate("/login");
      return;
    }

    const itemType = item.type === "workspace" ? "house" : item.type;

    const exists = wishlist.some(
      (w) => w.id === item.id && w.type === itemType,
    );

    let updated;

    if (exists) {
      updated = wishlist.filter(
        (w) => !(w.id === item.id && w.type === itemType),
      );
    } else {
      updated = [...wishlist, { ...item, type: itemType }];
    }

    setWishlist(updated);

    localStorage.setItem(`wishlist_${user.id}`, JSON.stringify(updated));

    window.dispatchEvent(new Event("cartUpdated"));
  };

  /* ================= FETCH ================= */

  useEffect(() => {
    fetch(`${API.SEARCH}&query=${query}&type=${type}`)
      .then((res) => res.json())
      .then((data) => setResults(data))
      .catch((err) => console.log(err));
  }, [query, type]);

  /* ================= UI ================= */

  return (
    <div className="container-fluid py-4">
      <div className="row">
        {/* ================= LEFT ================= */}

        <div className="col-lg-10">
          <div className="mb-3">
            <button
              onClick={() => navigate(-1)}
              className="btn btn-light back-btn"
            >
              <i className="bi bi-arrow-left"></i> Back
            </button>
          </div>

          <h4 className="mb-4">
            Search Results for :<span className="text-primary"> {query}</span>
          </h4>

          <div className="designs-grid1">
            {results.length > 0 ? (
              results.map((item) => {
                const images = item.image ? item.image.split(",") : [];

                const checkType =
                  item.type === "workspace" ? "house" : item.type;

                const isLiked = wishlist.some(
                  (w) => w.id === item.id && w.type === checkType,
                );

                /* ================= MACHINE ================= */

                if (item.type === "machine") {
                  return (
                    <div className="design-card" key={item.id}>
                      <div className="machine-img-container">
                        <img
                          src={`${UPLOADS.MACHINE_IMAGE}${images[0]}`}
                          alt={item.machine_name}
                        />

                        <span className="heads-badge">
                          {item.NoOfHeads} Heads
                        </span>
                      </div>

                      <div className="machine-body">
                        <div className="machine-type1">
                          <h4 className="machine-name">{item.machine_name}</h4>
                        </div>
                        <div className="d-flex align-items-center justify-content-between mt-2">
                          <div className="price-block">
                            <span className="currency-symbol">₹</span>
                            <span className="amount">
                              {Number(item.price).toLocaleString("en-IN")}
                            </span>
                          </div>
                          <button
                            className="contact-btn"
                            onClick={() =>
                              navigate(`/productdetails/${item.id}`)
                            }
                          >
                            <i className="bi bi-telephone-fill me-1"></i>{" "}
                            Contact
                          </button>
                        </div>
                        <div className="spec-row mt-2">
                          <div className="spec-item">
                            <span className="spec-label">Brand:</span>
                            <span className="spec-value">{item.brand}</span>
                          </div>
                          <div className="spec-item">
                            <span className="spec-label">Model:</span>
                            <span className="spec-value">{item.model}</span>
                          </div>
                        </div>
                        <div className="location-info">
                          <i className="bi bi-geo-alt-fill"></i> {item.city},{" "}
                          {item.state}
                        </div>
                        <div className="machine-footer mt-1">
                          <button
                            className="more-details-btn"
                            onClick={() =>
                              navigate(`/productdetails/${item.id}`)
                            }
                          >
                            <i className="bi bi-info-circle me-2"></i>
                            More Details
                          </button>

                          <button
                            className="footer-like-btn"
                            onClick={() => toggleWishlist(item)}
                          >
                            <i
                              className={`bi ${
                                isLiked
                                  ? "bi-heart-fill text-danger"
                                  : "bi-heart"
                              }`}
                            ></i>
                          </button>
                        </div>
                      </div>
                    </div>
                  );
                }

                /* ================= DESIGNER ================= */

                if (item.type === "designer") {
                  return (
                    <div className="design-card" key={item.id}>
                      <div className="machine-img-container">
                        <img
                          src={`${UPLOADS.DESIGNER_IMAGE}${item.profile}`}
                          className="designer-img"
                          alt={item.name}
                        />
                      </div>

                      <div className="machine-body">
                        <div className="machine-type1">
                          <h4 className="machine-name">{item.name}</h4>
                        </div>
                        <div className="d-flex align-items-center justify-content-between mt-2">
                          <div className="price-block">
                            <span className="currency-symbol">₹</span>
                            <span className="amount">
                              {item.expected_salary}
                            </span>
                            <span className="text-muted small"> / hour</span>
                          </div>
                          <button
                            className="contact-btn"
                            onClick={() =>
                              navigate(`/designerdetails/${item.id}`)
                            }
                          >
                            <i className="bi bi-telephone-fill me-1"></i>{" "}
                            Contact
                          </button>
                        </div>
                        <div className="spec-row mt-3">
                          <div className="spec-item">
                            <span className="spec-label">Skills:</span>
                            <span className="spec-value">{item.skills}</span>
                          </div>

                          <div className="spec-item">
                            <span className="spec-label">Exp:</span>
                            <span className="spec-value">
                              {item.experience}
                            </span>
                          </div>
                        </div>
                        <div className="location-info">
                          <i className="bi bi-geo-alt-fill"></i> {item.location}
                        </div>

                        <div className="machine-footer mt-1">
                          <button
                            className="more-details-btn"
                            onClick={() =>
                              navigate(`/designerdetails/${item.id}`)
                            }
                          >
                            <i className="bi bi-person-badge-fill me-2"></i>
                            Hire Now
                          </button>

                          <button
                            className="footer-like-btn"
                            onClick={() => toggleWishlist(item)}
                          >
                            <i
                              className={`bi ${
                                isLiked
                                  ? "bi-heart-fill text-danger"
                                  : "bi-heart"
                              }`}
                            ></i>
                          </button>
                        </div>
                      </div>
                    </div>
                  );
                }

                /* ================= WORKSPACE ================= */

                if (item.type === "workspace") {
                  return (
                    <div className="design-card" key={item.id}>
                      <div className="machine-img-container">
                        <img
                          src={`${UPLOADS.WORKSPACE_IMAGE}${images[0]}`}
                          alt="workspace"
                        />
                      </div>

                      <div className="machine-body">
                        <div className="machine-type1">
                          <h4 className="machine-name">{item.location}</h4>
                        </div>
                        <div className="d-flex align-items-center justify-content-between mt-2">
                          <div className="price-block">
                            <span className="currency-symbol">₹</span>
                            <span className="amount">
                              {parseInt(item.rent_price).toLocaleString(
                                "en-IN",
                              )}
                            </span>
                            <span className="rent-unit"> </span>
                          </div>
                          <button
                            className="contact-btn"
                            onClick={() =>
                              navigate(`/houserentDetails/${item.id}`)
                            }
                          >
                            <i className="bi bi-telephone-fill me-1"></i>{" "}
                            Contact
                          </button>
                        </div>

                        <div className="spec-row mt-2">
                          <div className="spec-item">
                            <span className="spec-label">Size:</span>
                            <span className="spec-value"> {item.size} </span>
                          </div>
                          <div className="spec-item">
                            <span className="spec-label">Floor:</span>
                            <span className="spec-value"> {item.floor}</span>
                          </div>
                        </div>

                        <div className="location-info">
                          <i className="bi bi-geo-alt-fill"></i>
                          {item.city},{item.state}
                        </div>

                        <div className="machine-footer mt-1">
                          <button
                            className="more-details-btn"
                            onClick={() =>
                              navigate(`/houserentDetails/${item.id}`)
                            }
                          >
                            <i className="bi bi-info-circle me-2"></i> View
                            Details
                          </button>

                          <button
                            className="footer-like-btn"
                            onClick={() => toggleWishlist(item)}
                          >
                            <i
                              className={`bi ${
                                isLiked
                                  ? "bi-heart-fill text-danger"
                                  : "bi-heart"
                              }`}
                            ></i>
                          </button>
                        </div>
                      </div>
                    </div>
                  );
                }

                return null;
              })
            ) : (
              <h5>No Results Found</h5>
            )}
          </div>
        </div>

        {/* ================= RIGHT ADS ================= */}

        <div className="col-lg-2">
          <div className="ads-sidebar">
            <h5>Sponsored</h5>

            <div className="ad-card">
              <img src="/img/ad1.jpg" alt="" />
              <p>Best Embroidery Machines</p>
            </div>

            <div className="ad-card">
              <img src="/img/ad2.jpg" alt="" />
              <p>Find Workspaces</p>
            </div>

            <div className="ad-card">
              <img src="/img/ad3.jpg" alt="" />
              <p>Hire Skilled Designers</p>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}
